import { render } from "./BasicCreationStep.vue?vue&type=template&id=463713b0"
import script from "./BasicCreationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicCreationStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/BasicCreationStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "463713b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('463713b0', __exports__)) {
    api.reload('463713b0', __exports__)
  }
  
  module.hot.accept("./BasicCreationStep.vue?vue&type=template&id=463713b0", () => {
    api.rerender('463713b0', render)
  })

}


export default __exports__